import PasswordValidator from "password-validator";
import moment from "moment";
import { NOT_ALLOWED_NAME_REGEX } from "../constants";

const uriHasOAuthStateId = () => {
  const uriParams = new URLSearchParams(window.location.search);
  return uriParams.has('oauth_state_id');
};
const uriHasOAuthLogin = () => {
  const uriParams = new URLSearchParams(window.location.search);
  return uriParams.has('oauth_login');
};

const isPasswordValid = (password) => {
  if(!password)
    return { error: `Password cannot be empty` };

  const passwordSchema = new PasswordValidator();
  const minCharacters = 8;
  const maxCharacters = 50;

  passwordSchema
    .is()
    .min(minCharacters) // Minimum length 8
    .is()
    .max(maxCharacters) // Maximum length 100
    .has()
    .uppercase() // Must have uppercase letters
    .has()
    .lowercase() // Must have lowercase letters
    .has()
    .digits() // Must have digits
    .has()
    .not()
    .spaces() // Should not have spaces
    .has()
    .symbols(1)  // Must have at least 1 symbol
    .is()
    .not()
    .oneOf(["Passw0rd", "Password123"]); // Blacklist these values

  const result = passwordSchema.validate(password, { list: true });

  if(result.includes("min"))
    return { error: `Password must contain at least ${minCharacters} characters` };
  if(result.includes("max"))
    return { error: `Password must contain ${maxCharacters} at most` };
  if(result.includes("uppercase"))
    return { error: `Password must contain uppercase characters` };
  if(result.includes("lowercase"))
    return { error: `Password must contain lowercase characters` };
  if(result.includes("digits"))
    return { error: `Password must contain a number` };
  if(result.includes("spaces"))
    return { error: `Password must not contain any spaces` };
  if(result.includes("symbols"))
    return { error: `Password must contain at least 1 symbol` };
  if(result.includes("oneOf"))
    return { error: `Your password is too generic. Please use a more unique password.` };

  return true;
};

const nameCheck = (name) => {
  const nameRegex = NOT_ALLOWED_NAME_REGEX;
  return (name.length >= 2 && name.length <= 30 && !nameRegex.test(name));
};

const getAge = (birthdayString) => {
  const today = new moment();
  const birthDate = new moment(birthdayString);
  let age = Number(today.format("YYYY") - birthDate.format("YYYY"));
  const month = Number(today.format("MM") - birthDate.format("MM"));
  if (month < 0 || (month === 0 && Number(today.format("DD")) < Number(birthDate.format("DD"))))
    age--;

  return age;
};

const sanitizePhoneNumber = (phoneNumber) =>
  (phoneNumber && phoneNumber.length
    ? phoneNumber.slice(
      phoneNumber.indexOf("+1") > -1 ? 2 : 0,
      phoneNumber.length,
    )
    : phoneNumber);

export {
  isPasswordValid,
  uriHasOAuthStateId,
  uriHasOAuthLogin,
  nameCheck,
  getAge,
  sanitizePhoneNumber,
};